module.exports = __webpack_public_path__ + "media/honey-icons/icon-tanks-6ad7c62f.svg";